import * as types from "../types";

export const getProgramSlots = () => ({
  type: types.GET_PROGRAM_SLOTS,
  request: {
    url: "/program_slots",
    method: "GET"
  }
});

export const getProgramEvents = ({ startAt, endAt }) => ({
  type: types.GET_PROGRAM_EVENTS,
  request: {
    url: "/program_events",
    method: "GET",
    params: {
      "q[start_at_gteq]": startAt,
      "q[start_at_lt]": endAt
    }
  },
  meta: {
    requestKey: `${startAt}${endAt}`
  }
});
